import { Component } from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import $ from 'jquery'

import * as h from 'h'
import { debounce } from 'utils'

import styles from './styles.scss'

@observer(['UiStore'])
export default class UconnLogo extends Component {
  componentWillMount () {
    this.visible = observable(false)
    this.checkScrolled()

    this.checkScrolledDebounced = debounce(::this.checkScrolled, 100)
    window.addEventListener('scroll', this.checkScrolledDebounced, true)
  }

  checkScrolled () {
    const $landing = $(this.props.landing)
    if ($landing.scrollTop() > 60) {
      this.visible.set(true)
    } else {
      this.visible.set(false)
    }
  }

  render () {
    let style = this.visible.get()
      ? { opacity: '1', pointerEvents: 'auto' }
      : {}
    return h.a({
      href: 'http://uconn.edu',
      style: style,
      ...h.ca(styles.uconnLogo),
      name: 'UConn Home Page'
    },
      h.img({
        src: '/img/uconn-wordmark-single-white.png',
        alt: 'UConn',
        name: 'UConn Logo'
      }))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Landing/UconnLogo.js